(function(angular){
	'use strict';

	var confirmationModalObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			confirmText: '@',
			confirmTitle: '@',
			disableConfirm: '<?',
			onConfirm: '&',
			showCancel: '<?'
		},
		transclude: true,
		controller: ['$scope', ConfirmationModalFunction],
		controllerAs: 'confirmationModal'
	};

	angular
		.module('confirmationModalModule')
		.component('confirmationModal', confirmationModalObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/confirmation-modal/confirmation-modal.html';
	}

	function ConfirmationModalFunction($scope){
		var confirmationModal = this;

		confirmationModal.$onInit = function() {
			if(angular.isUndefined(confirmationModal.disableConfirm)) {
				confirmationModal.disableConfirm = false;
			}
		
			confirmationModal.shown = false;
			confirmationModal.showCancel = confirmationModal.showCancel || false;
		};

		confirmationModal.dismiss = function() {
			confirmationModal.shown = false;
		};

		confirmationModal.confirm = function() {
			if(!confirmationModal.disableConfirm) {
				confirmationModal.onConfirm();
				confirmationModal.shown = false;
			}
		};

		$scope.$on('confirmationModal:open', function(evt, data) {
			confirmationModal.shown = true;
		});
	}
})(window.angular);
